(() => {
const SUN = 0;
const MON = 1;
const TUE = 2;
const WED = 3;
const THU = 4;
const FRI = 5;
const SAT = 6;

const MAX_DISPATCH_DAYS = 5;

const MARKETS = {
  'european-union': {
    timezone: 'Europe/Amsterdam',
    cutoff: '10:00',
    workingDays: [MON, TUE, WED, THU, FRI],
    extraWorkingDays: 0,
    // https://www.rijksoverheid.nl/vraag-en-antwoord/arbeidsovereenkomst-en-cao/officiele-feestdagen
    holidays: [
      // 2026
      '2026-01-01', // New Year
      '2026-04-03', // Good Friday
      '2026-04-06', // Easter Monday
      '2026-04-27', // King's Day
      '2026-05-05', // Liberation Day
      '2026-05-14', // Ascension
      '2026-05-25', // Whit Monday
      '2026-12-25', // Christmas
      // 2027
      '2027-01-01', // New Year
      '2027-03-26', // Good Friday
      '2027-03-29', // Easter Monday
      '2027-04-27', // King's Day
      '2027-05-05', // Liberation Day
      '2027-05-06', // Ascension
      '2027-05-17', // Whit Monday
      // 2028
      '2028-04-14', // Good Friday
      '2028-04-17', // Easter Monday
      '2028-04-27', // King's Day
      '2028-05-05', // Liberation Day
      '2028-05-25', // Ascension
      '2028-06-05', // Whit Monday
      '2028-12-25', // Christmas
      '2028-12-26', // Boxing Day
      // 2029
      '2029-01-01', // New Year
      '2029-03-30', // Good Friday
      '2029-04-02', // Easter Monday
      '2029-04-27', // King's Day
      '2029-05-10', // Ascension
      '2029-05-21', // Whit Monday
      '2029-12-25', // Christmas
      '2029-12-26', // Boxing Day
      // 2030
      '2030-01-01', // New Year
      '2030-04-19', // Good Friday
      '2030-04-22', // Easter Monday
      '2030-05-30', // Ascension
      '2030-06-10', // Whit Monday
      '2030-12-25', // Christmas
      '2030-12-26', // Boxing Day
    ],
  },
  'united-kingdom': {
    timezone: 'Europe/London',
    cutoff: '11:00',
    workingDays: [MON, TUE, WED, THU, FRI],
    extraWorkingDays: 0,
    // https://gov.uk/bank-holidays.json
    // for england-and-wales
    holidays: [
      // 2026
      '2026-01-01', // New Year
      '2026-04-03', // Good Friday
      '2026-04-06', // Easter Monday
      '2026-05-04', // Early May BH
      '2026-05-25', // Spring BH
      '2026-08-31', // Summer BH
      '2026-12-25', // Christmas
      '2026-12-28', // Boxing Day (substitute)
      // 2027
      '2027-01-01', // New Year
      '2027-03-26', // Good Friday
      '2027-03-29', // Easter Monday
      '2027-05-03', // Early May BH
      '2027-05-31', // Spring BH
      '2027-08-30', // Summer BH
      '2027-12-27', // Christmas (substitute)
      '2027-12-28', // Boxing Day (substitute)
      // 2028
      '2028-01-03', // New Year (substitute)
      '2028-04-14', // Good Friday
      '2028-04-17', // Easter Monday
      '2028-05-01', // Early May BH
      '2028-05-29', // Spring BH
      '2028-08-28', // Summer BH
      '2028-12-25', // Christmas
      '2028-12-26', // Boxing Day
      // 2029
      '2029-01-01', // New Year
      '2029-03-30', // Good Friday
      '2029-04-02', // Easter Monday
      '2029-05-07', // Early May BH
      '2029-05-28', // Spring BH
      '2029-08-27', // Summer BH
      '2029-12-25', // Christmas
      '2029-12-26', // Boxing Day
      // 2030
      '2030-01-01', // New Year
      '2030-04-19', // Good Friday
      '2030-04-22', // Easter Monday
      '2030-05-06', // Early May BH
      '2030-05-27', // Spring BH
      '2030-08-26', // Summer BH
      '2030-12-25', // Christmas
      '2030-12-26', // Boxing Day
    ],
  },
  'canada': {
    timezone: 'America/Toronto',
    cutoff: '11:00',
    workingDays: [MON, TUE, WED, THU, FRI],
    extraWorkingDays: 1,
    // https://canada-holidays.ca/provinces/ON
    // including optional
    holidays: [
      // 2026
      '2026-01-01', // New Year
      '2026-02-16', // Family Day
      '2026-04-03', // Good Friday
      '2026-04-06', // Easter Monday
      '2026-05-18', // Victoria Day
      '2026-07-01', // Canada Day
      '2026-08-03', // Civic Holiday
      '2026-09-07', // Labour Day
      '2026-10-12', // Thanksgiving
      '2026-11-11', // Remembrance Day
      '2026-12-25', // Christmas
      '2026-12-28', // Boxing Day (observed)
      // 2027
      '2027-01-01', // New Year
      '2027-02-15', // Family Day
      '2027-03-26', // Good Friday
      '2027-03-29', // Easter Monday
      '2027-05-24', // Victoria Day
      '2027-07-01', // Canada Day
      '2027-08-02', // Civic Holiday
      '2027-09-06', // Labour Day
      '2027-10-11', // Thanksgiving
      '2027-11-11', // Remembrance Day
      '2027-12-27', // Christmas (observed)
      '2027-12-28', // Boxing Day (observed)
      // 2028
      '2028-01-03', // New Year (observed)
      '2028-02-21', // Family Day
      '2028-04-14', // Good Friday
      '2028-04-17', // Easter Monday
      '2028-05-22', // Victoria Day
      '2028-07-03', // Canada Day (observed)
      '2028-08-07', // Civic Holiday
      '2028-09-04', // Labour Day
      '2028-10-09', // Thanksgiving
      '2028-11-13', // Remembrance Day (observed)
      '2028-12-25', // Christmas
      '2028-12-26', // Boxing Day
      // 2029
      '2029-01-01', // New Year
      '2029-02-19', // Family Day
      '2029-03-30', // Good Friday
      '2029-04-02', // Easter Monday
      '2029-05-21', // Victoria Day
      '2029-07-02', // Canada Day (observed)
      '2029-08-06', // Civic Holiday
      '2029-09-03', // Labour Day
      '2029-10-08', // Thanksgiving
      '2029-11-12', // Remembrance Day (observed)
      '2029-12-25', // Christmas
      '2029-12-26', // Boxing Day
      // 2030
      '2030-01-01', // New Year
      '2030-02-18', // Family Day
      '2030-04-19', // Good Friday
      '2030-04-22', // Easter Monday
      '2030-05-20', // Victoria Day
      '2030-07-01', // Canada Day
      '2030-08-05', // Civic Holiday
      '2030-09-02', // Labour Day
      '2030-10-14', // Thanksgiving
      '2030-11-11', // Remembrance Day
      '2030-12-25', // Christmas
      '2030-12-26', // Boxing Day
    ],
  },
  'united-states': {
    timezone: 'America/Los_Angeles',
    cutoff: '09:00',
    workingDays: [MON, TUE, WED, THU, FRI],
    extraWorkingDays: 0,
    holidays: [
      // 2026
      '2026-01-01', // New Year
      '2026-01-19', // MLK Day
      '2026-02-16', // Presidents' Day
      '2026-05-25', // Memorial Day
      '2026-06-19', // Juneteenth
      '2026-07-03', // Independence Day (observed)
      '2026-09-07', // Labor Day
      '2026-10-12', // Columbus Day
      '2026-11-11', // Veterans Day
      '2026-11-26', // Thanksgiving
      '2026-12-25', // Christmas
      // 2027
      '2027-01-01', // New Year
      '2027-01-18', // MLK Day
      '2027-02-15', // Presidents' Day
      '2027-05-31', // Memorial Day
      '2027-06-18', // Juneteenth (observed)
      '2027-07-05', // Independence Day (observed)
      '2027-09-06', // Labor Day
      '2027-10-11', // Columbus Day
      '2027-11-11', // Veterans Day
      '2027-11-25', // Thanksgiving
      '2027-12-24', // Christmas (observed)
      '2027-12-31', // New Year 2028 (observed)
      // 2028
      '2028-01-17', // MLK Day
      '2028-02-21', // Presidents' Day
      '2028-05-29', // Memorial Day
      '2028-06-19', // Juneteenth
      '2028-07-04', // Independence Day
      '2028-09-04', // Labor Day
      '2028-10-09', // Columbus Day
      '2028-11-10', // Veterans Day (observed)
      '2028-11-23', // Thanksgiving
      '2028-12-25', // Christmas
      // 2029
      '2029-01-01', // New Year
      '2029-01-15', // MLK Day
      '2029-02-19', // Presidents' Day
      '2029-05-28', // Memorial Day
      '2029-06-19', // Juneteenth
      '2029-07-04', // Independence Day
      '2029-09-03', // Labor Day
      '2029-10-08', // Columbus Day
      '2029-11-12', // Veterans Day (observed)
      '2029-11-22', // Thanksgiving
      '2029-12-25', // Christmas
      // 2030
      '2030-01-01', // New Year
      '2030-01-21', // MLK Day
      '2030-02-18', // Presidents' Day
      '2030-05-27', // Memorial Day
      '2030-06-19', // Juneteenth
      '2030-07-04', // Independence Day
      '2030-09-02', // Labor Day
      '2030-10-14', // Columbus Day
      '2030-11-11', // Veterans Day
      '2030-11-28', // Thanksgiving
      '2030-12-25', // Christmas
    ],
  },
};

/**
 * @typedef {{ year: number, month: number, day: number, weekday: number }} Ymd 0=Sun … 6=Sat
 * @typedef {{ timezone: string, cutoff: string, workingDays: number[], extraWorkingDays: number, holidays: string[] }} MarketConfig
 */

/** @type {Record<string, Intl.DateTimeFormat>} */
const formatters = {};

/** @param {number} year @param {number} month @param {number} day @returns {Ymd} */
function fromYmd(year, month, day) {
  const date = new Date(Date.UTC(year, month - 1, day, 12));
  return {
    year: date.getUTCFullYear(),
    month: date.getUTCMonth() + 1,
    day: date.getUTCDate(),
    weekday: date.getUTCDay(),
  };
}

/** @param {Ymd} ymd @param {number} days @returns {Ymd} */
function addDays(ymd, days) {
  return fromYmd(ymd.year, ymd.month, ymd.day + days);
}

/** @param {Ymd} from @param {Ymd} to @returns {number} whole calendar days from `from` to `to` */
function daysBetween(from, to) {
  const a = Date.UTC(from.year, from.month - 1, from.day);
  const b = Date.UTC(to.year, to.month - 1, to.day);
  return Math.round((b - a) / 86400000);
}

/** @param {Pick<Ymd, 'year' | 'month' | 'day'>} ymd */
function formatISODate(ymd) {
  return `${ymd.year}-${String(ymd.month).padStart(2, '0')}-${String(ymd.day).padStart(2, '0')}`;
}

/** @param {number} ms @param {string} timeZone */
function wallClock(ms, timeZone) {
  let fmt = formatters[timeZone];
  if (!fmt) {
    fmt = new Intl.DateTimeFormat('en-US', {
      timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23',
    });
    formatters[timeZone] = fmt;
  }
  /** @type {Record<string, string>} */
  const values = {};
  for (const part of fmt.formatToParts(new Date(ms))) {
    if (part.type !== 'literal') values[part.type] = part.value;
  }
  let hour = Number(values.hour);
  if (hour === 24) hour = 0;
  return {
    year: Number(values.year),
    month: Number(values.month),
    day: Number(values.day),
    hour,
    minute: Number(values.minute),
  };
}

/** @param {{ year: number, month: number, day: number, hour: number, minute: number }} parts @param {string} timeZone */
function zonedTimeToUtc(parts, timeZone) {
  const guess = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute);
  const got = wallClock(guess, timeZone);
  const asUtc = Date.UTC(got.year, got.month - 1, got.day, got.hour, got.minute);
  return guess - (asUtc - guess);
}

/** @param {Ymd} ymd @param {MarketConfig} config @param {Set<string>} holidays */
function isOpen(ymd, config, holidays) {
  return config.workingDays.includes(ymd.weekday) && !holidays.has(formatISODate(ymd));
}

/** @param {Ymd} start @param {MarketConfig} config @param {Set<string>} holidays */
function nextOpen(start, config, holidays) {
  let date = start;
  for (let i = 0; i < 14; i++) {
    if (isOpen(date, config, holidays)) return date;
    date = addDays(date, 1);
  }
  return null;
}

/** @param {number} nowMs @param {MarketConfig} config */
function computeDispatch(nowMs, config) {
  const now = wallClock(nowMs, config.timezone);
  const holidays = new Set(config.holidays);
  const today = fromYmd(now.year, now.month, now.day);
  const cutoffParts = config.cutoff.split(':');
  const cutoffHour = Number(cutoffParts[0]);
  const cutoffMinute = Number(cutoffParts[1] ?? 0);
  const beforeCutoff = now.hour * 60 + now.minute < cutoffHour * 60 + cutoffMinute;

  const order =
    isOpen(today, config, holidays) && beforeCutoff ? today : nextOpen(addDays(today, 1), config, holidays);
  if (!order) return null;

  let dispatch = order;
  for (let i = 0; i < config.extraWorkingDays; i++) {
    const next = nextOpen(addDays(dispatch, 1), config, holidays);
    if (!next) return null;
    dispatch = next;
  }

  const cutoffInstant = zonedTimeToUtc(
    { year: order.year, month: order.month, day: order.day, hour: cutoffHour, minute: cutoffMinute },
    config.timezone,
  );
  return {
    dispatchDate: dispatch,
    cutoffInstant,
    msRemaining: cutoffInstant - nowMs,
    daysUntilDispatch: daysBetween(today, dispatch),
  };
}

/** @param {number} ms */
function formatDuration(ms) {
  const total = Math.max(1, Math.floor(ms / 60000));
  const days = Math.floor(total / 1440);
  const hours = Math.floor((total % 1440) / 60);
  const minutes = total % 60;
  /** @type {string[]} */
  const parts = [];
  if (days) parts.push(`${days} ${days === 1 ? 'day' : 'days'}`);
  if (hours) parts.push(`${hours} ${hours === 1 ? 'hr' : 'hrs'}`);
  if (minutes || !parts.length) parts.push(`${minutes} ${minutes === 1 ? 'min' : 'mins'}`);
  return parts.join(' ');
}

/** @param {Ymd} dispatchDate @param {number} nowMs @param {string} timeZone */
function formatWhen(dispatchDate, nowMs, timeZone) {
  const now = wallClock(nowMs, timeZone);
  const today = fromYmd(now.year, now.month, now.day);
  if (formatISODate(dispatchDate) === formatISODate(today)) return 'today';
  if (formatISODate(dispatchDate) === formatISODate(addDays(today, 1))) return 'tomorrow';
  return new Intl.DateTimeFormat('en', { weekday: 'long', timeZone: 'UTC' }).format(
    new Date(Date.UTC(dispatchDate.year, dispatchDate.month - 1, dispatchDate.day, 12)),
  );
}

/** @param {string} raw @param {string} timeZone */
function parseNowOverride(raw, timeZone) {
  if (/[zZ]|[+-]\d{2}:\d{2}$/.test(raw)) {
    const parsed = Date.parse(raw);
    return Number.isNaN(parsed) ? null : parsed;
  }
  const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/.exec(raw);
  if (!match) return null;
  return zonedTimeToUtc(
    {
      year: Number(match[1]),
      month: Number(match[2]),
      day: Number(match[3]),
      hour: Number(match[4]),
      minute: Number(match[5]),
    },
    timeZone,
  );
}

if (typeof HTMLElement !== 'undefined') {
  class DispatchCutoff extends HTMLElement {
    /** @type {ReturnType<typeof setTimeout> | undefined} */
    timer;

    connectedCallback() {
      window.onAbReady = (ab) => {
        if (!ab.shouldShowDispatchCutoff()) return;
        this.draw();
      };
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
    }

    draw() {
      clearTimeout(this.timer);
      const config = MARKETS[this.getAttribute('market') ?? ''];
      if (!config) {
        this.hidden = true;
        return;
      }

      const override = new URLSearchParams(location.search).get('dispatch_now');
      const now = (override && parseNowOverride(override, config.timezone)) || Date.now();
      const local = wallClock(now, config.timezone);
      if (local.month === 12 && local.day >= 20) {
        this.hidden = true;
        return;
      }

      const result = computeDispatch(now, config);
      if (!result) {
        this.hidden = true;
        return;
      }

      if (result.daysUntilDispatch > MAX_DISPATCH_DAYS) {
        this.hidden = true;
        return;
      }

      this.hidden = false;
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
      const when = formatWhen(result.dispatchDate, now, tz);
      const dayMs = 24 * 60 * 60 * 1000;
      this.replaceChildren();
      if (result.msRemaining >= dayMs) {
        this.append(`In stock. Order now, dispatched ${when}`);
        this.timer = setTimeout(() => this.draw(), Math.max(250, result.msRemaining - dayMs + 1));
      } else {
        const time = document.createElement('strong');
        time.textContent = formatDuration(result.msRemaining);
        this.append('In stock. Order within ', time, `, dispatched ${when}`);
        this.timer = setTimeout(() => this.draw(), Math.min(60000, Math.max(250, result.msRemaining)));
      }
    }
  }

  if (!customElements.get('dispatch-cutoff')) {
    customElements.define('dispatch-cutoff', DispatchCutoff);
  }
}
})();
